// extracted by mini-css-extract-plugin
export var textInput = "_in-0";